var map = {
	"./cinema-11.png": 1378,
	"./cinema-12.png": 1379,
	"./cinema-13.png": 1380,
	"./cinema-14.png": 1381,
	"./cinema-15.png": 1382,
	"./cinema-16.png": 1383,
	"./cinema-17.png": 1384,
	"./cinema-18.png": 1385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1377;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img ^\.\/cinema\-1.*\.png$
// module id = 1377
// module chunks = 4